// Spanish for the SOS Field app: server. Keys are the English text exactly as written in the code.
// Messages from the Django field API (backend/field_photos) and Django REST framework, shown on the phone
// through fieldErrorMessage. Keys must match the server text exactly.
export default {
  // field_photos/views.py
  "That's the crew PIN. Enter your personal PIN (it's different from the crew PIN).":
    'Ese es el PIN del equipo. Ingresa tu PIN personal (es diferente del PIN del equipo).',
  'This phone has no personal time clock account yet. The office creates it in Setup → Crews → your crew → SOS Field app, with its own PIN.':
    'Este teléfono todavía no tiene una cuenta personal de reloj. La oficina la crea en Setup → Crews → tu equipo → SOS Field app, con su propio PIN.',
  'Phone number or PIN is incorrect. If this keeps happening, ask the office to check your PIN.':
    'El número de teléfono o el PIN no es correcto. Si sigue pasando, pide a la oficina que revise tu PIN.',
  'Too many attempts. Wait 15 minutes and try again.':
    'Demasiados intentos. Espera 15 minutos y vuelve a intentarlo.',
  "You don't have access to any department yet. Ask the office to turn it on for you.":
    'Todavía no tienes acceso a ningún departamento. Pide a la oficina que te lo active.',
  'Unknown organization.': 'Organización desconocida.',
  "You don't have access to this department.":
    'No tienes acceso a este departamento.',
  'This file is not a job photo.': 'Este archivo no es una foto del trabajo.',

  // field_photos/time_clock.py
  'The time on this phone is ahead. Check the device clock.':
    'La hora de este teléfono está adelantada. Revisa el reloj del teléfono.',
  'Sign in with an office-issued personal time clock account.':
    'Entra con una cuenta personal de reloj que te dio la oficina.',
  'The signed-in worker changed. Sign in to your own account.':
    'Cambió el trabajador que inició sesión. Entra con tu propia cuenta.',
  'This punch ID already belongs to another event.':
    'Este ID de marcación ya es de otro registro.',
  'Another device changed this clock. Review the recorded punches.':
    'Otro dispositivo cambió este reloj. Revisa las marcaciones guardadas.',
  'This punch predates the last recorded punch. Contact the office.':
    'Esta marcación es anterior a la última marcación guardada. Comunícate con la oficina.',
  'Your office requires GPS at clock-in. Enable shift GPS on this phone.':
    'Tu oficina pide GPS al marcar entrada. Activa el GPS del turno en este teléfono.',
  'Enable shift GPS at clock-in with a current location.':
    'Activa el GPS del turno al marcar entrada, con tu ubicación actual.',
  'Choose an active CRM account in this organization.':
    'Elige una cuenta activa del CRM en esta organización.',
  'This CRM account is already linked to a different worker.':
    'Esta cuenta del CRM ya está conectada a otro trabajador.',
  'This phone already has a personal account in this organization.':
    'Este teléfono ya tiene una cuenta personal en esta organización.',
  'Choose a personal PIN different from the crew PIN.':
    'Elige un PIN personal diferente del PIN del equipo.',
  'This phone number or CRM account is already assigned.':
    'Este número de teléfono o cuenta del CRM ya está asignado.',
  'Create a new account for a different personal number.':
    'Crea una cuenta nueva para otro número personal.',
  'This CRM account is already linked to another worker.':
    'Esta cuenta del CRM ya está conectada a otro trabajador.',

  // field_photos/timesheets.py
  'Choose a week between 1970 and next week.':
    'Elige una semana entre 1970 y la próxima semana.',
  'Choose a valid time zone.': 'Elige una zona horaria válida.',

  // field_photos/shift_gps.py
  'Account changed.': 'La cuenta cambió.',
  'Sync the clock-in before sending GPS points.':
    'Sincroniza la entrada antes de enviar puntos de GPS.',
  'GPS was not enabled for this shift.':
    'El GPS no estaba activado para este turno.',
  'Choose one day.': 'Elige un día.',

  // field_photos/sales.py
  'A linked Field marketing account is required.':
    'Necesitas una cuenta de ventas de Field conectada.',
  'This action needs a linked Field sales account with Marketing and Contracts.':
    'Para esto necesitas una cuenta de ventas de Field conectada, con Ventas y Contratos.',
  'Set the estimate to Need to sign or Signed before preparing a contract.':
    'Cambia el presupuesto a Need to sign o Signed antes de preparar un contrato.',

  // field_photos/serializers.py
  'Enter your full phone number (10 digits).':
    'Ingresa tu número de teléfono completo (10 dígitos).',
  'Send a location (latitude and longitude) or a search text (q).':
    'Envía una ubicación (latitud y longitud) o un texto de búsqueda (q).',
  'Turn on location to upload photos.': 'Activa la ubicación para subir fotos.',
  'The photo is larger than 20 MB.': 'La foto pesa más de 20 MB.',
  'The file is not a supported image.':
    'El archivo no es una imagen compatible.',
  'Only JPEG, PNG and WebP photos are supported.':
    'Solo se aceptan fotos JPEG, PNG y WebP.',
  'Send either a project or a field_project.':
    'Envía un project o un field_project, no los dos.',
  'Project not found.': 'No se encontró el proyecto.',

  // field_photos/authentication.py
  'Invalid field token header.':
    'El encabezado del token de Field no es válido.',
  'Your session expired. Please sign in again.':
    'Tu sesión venció. Vuelve a iniciar sesión.',
  'Personal access was changed. Sign in again.':
    'Tu acceso personal cambió. Vuelve a iniciar sesión.',
  'Your access to SOS Field was turned off. Ask the office.':
    'Se desactivó tu acceso a SOS Field. Pregunta en la oficina.',

  // Django REST framework
  'This field is required.': 'Este campo es obligatorio.',
  'Authentication credentials were not provided.':
    'No se enviaron los datos de inicio de sesión. Vuelve a iniciar sesión.',
  'You do not have permission to perform this action.':
    'No tienes permiso para hacer esto.',
  'Not found.': 'No se encontró.',
  'A valid integer is required.': 'Se necesita un número entero válido.',
  'Enter a valid date/time.': 'Ingresa una fecha y hora válidas.',

  // Client fallback (composables/useField.ts)
  'Something went wrong. Check your connection and try again.':
    'Algo salió mal. Revisa tu conexión y vuelve a intentarlo.',
  'Sales is not turned on for you. Ask the office.':
    'Ventas no está activado para ti. Pregunta en la oficina.',
  'This contract has been sent already.': 'Este contrato ya se envió.',
  'Choose a company field on a draft contract.':
    'Elige un campo de la empresa en un contrato que todavía no se envió.',
  'Add at least one recipient who needs to sign.':
    'Agrega al menos una persona que tenga que firmar.',
} as Record<string, string>
